import axios from '@axios'
import { API_URL } from '@/env/environment'
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchProducts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${API_URL}productos`, { params: queryParams })
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
    fetchUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${API_URL}usuarios/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    add(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${API_URL}productos`, userData)
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
  },
}
